import { IProduct } from "../../types/product.types";
import {
  IStock,
  IStockDetailTable,
  IStockTable,
} from "../../types/stock.types";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";

const API_URL = import.meta.env.VITE_API_URL;
type GetStocksOptions = {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: string;
};

const makeRequestDebouncedMinIventory = createDebounce(makeRequest, 200);
export async function getMinInventory() {
  const url = `${API_URL}/stock-min`;
  const result = (await makeRequestDebouncedMinIventory(
    url,
  )) as ApiResponseType<IProduct[]>;
  return { data: result.data };
}

const makeRequestDebouncedPaginationStock = createDebounce(makeRequest, 200);
export async function getStocks(options: GetStocksOptions = {}) {
  const { status = [], search = "", page = 1, itemsPerPage = "30" } = options;
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);

  const url = `${API_URL}/stocks?${params.toString()}`;
  const result = (await makeRequestDebouncedPaginationStock(
    url,
  )) as ApiResponseType<IStockTable[]> & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

const makeRequestDebouncedStockId = createDebounce(makeRequest, 200);
export async function getStockById(stockId: string) {
  const url = `${API_URL}/stock/${stockId}`;
  return (await makeRequestDebouncedStockId(
    url,
  )) as ApiResponseType<IStockDetailTable>;
}

export async function getStockByProductId(productId: string) {
  const url = `${API_URL}/stock/product/${productId}`;
  return (await makeRequestDebouncedStockId(url)) as ApiResponseType<IStock>;
}

const makeRequestDebouncedrReleaseStock = createDebounce(makeRequest, 200);
export async function releaseStock() {
  const url = `${API_URL}/stock`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };

  const result = makeRequestDebouncedrReleaseStock(url, options) as Promise<
    ApiResponseType<IStock>
  >;

  return result;
}

const makeRequestDebouncedCreateStock = createDebounce(makeRequest, 200);
export async function createStock(data) {
  const url = `${API_URL}/stock`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...data, companyId: getCompanyId() }),
  };

  const result = makeRequestDebouncedCreateStock(url, options) as Promise<
    ApiResponseType<IStock>
  >;

  return result;
}

const makeRequestDebouncedInventoryStock = createDebounce(makeRequest, 200);
export async function inventoryStock(data: {
  stockId: string;
  quantity: number;
}) {
  const url = `${API_URL}/stock-inventory`;
  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebouncedInventoryStock(url, options) as Promise<
    ApiResponseType<IStock>
  >;

  return result;
}

export type IAverageConsumption = {
  code: string;
  name: string;
  daysConsumption: number;
  quantity: number;
};

const makeRequestDebouncedAverageConsumption = createDebounce(makeRequest, 200);
export async function getAverageConsumption() {
  const url = `${API_URL}/stock-avarage-consumption`;
  const result = (await makeRequestDebouncedAverageConsumption(
    url,
  )) as ApiResponseType<IAverageConsumption[]>;
  return { data: result.data };
}
